import { render } from "./DashboardLayout.vue?vue&type=template&id=3c04ecf8&ts=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/ev-connect-dashboard/ev-connect-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__